import React, {forwardRef, HTMLAttributes} from 'react';
import classNames from 'classnames';

// import {Action, Handle, Remove} from '../../CoreComponents';

import styles from './TreeItem.module.css';

export interface Props extends Omit<HTMLAttributes<HTMLLIElement>, 'id'> {
  childCount?: number;
  clone?: boolean;
  collapsed?: boolean;
  depth: number;
  category: string;
  activePageId: number | null;
  disableInteraction?: boolean;
  disableSelection?: boolean;
  ghost?: boolean;
  handleProps?: any;
  indicator?: boolean;
  indentationWidth: number;
  value: string;
  onItemBtnClick?(event: MouseEvent):void;
  btn1?: string;
  onBtn1?(): void;
  btn2?: string;
  onBtn2?(): void;
  onCollapse?(): void;
  onRemove?(): void;
  wrapperRef?(node: HTMLLIElement): void;
  visible?: boolean;
  locked?: boolean;
  missingMedia?: boolean;
  isDragActive?: boolean,
  allowNesting?: boolean,
  onContextMenuBtn(event: MouseEvent):void;
}



export const TreeItem = forwardRef<HTMLDivElement, Props>(
  (
    {
      childCount,
      clone,
      depth,
      activePageId,
      category,
      disableSelection,
      disableInteraction,
      ghost,
      handleProps,
      indentationWidth,
      indicator,
      collapsed,
      onCollapse,
      onRemove,
      onItemBtnClick,
      onBtn1,
      onBtn2,
      btn1,
      btn2,
      style,
      value,
      visible,
      locked,
      missingMedia,
      wrapperRef,
      onContextMenuBtn,
      ...props
    },
    ref
  ) => {
  
    type handleBtnEvent = (event: MouseEvent) => void;

    function handleBtn1() {
      // console.log('handleBtn1')
      // if (e && e.target && (e.target instanceof HTMLElement)){
      //   e.target.classList.toggle('isVisible');
      //   e.target.classList.toggle('notVisible');
      // }
      
      onBtn1 && onBtn1()
    }

    function handleBtn2() {
      // if (e && e.target && e.target instanceof HTMLElement){
      //   e.target.classList.toggle('isLocked');
      // }
      onBtn2 && onBtn2()
    }

    function textValue() {
      let result = value
      if (category === 'folders') {
        result = folderIcon + ' ' + value
      }
      return result 
    }
    

    return (
      <li
        className={classNames(
          styles.Wrapper,
          clone && styles.clone,
          ghost && styles.ghost,
          indicator && styles.indicator,
          disableSelection && styles.disableSelection,
          disableInteraction && styles.disableInteraction,
          activePageId === 1 && "pageOn",
          missingMedia && "hasMissingMedia"
        )}
        ref={wrapperRef}
    
        style={
          {
            '--spacing': `${indentationWidth * depth}px`,
          } as React.CSSProperties
        }
        {...props}
      >
        <div className={classNames(
          styles.TreeItem,
          (depth > 0) && styles.subItem
          )} ref={ref} style={style} >
            
          {onCollapse ? (
            <span
              onClick={onCollapse}
              className={classNames(
                styles.Collapse,
                collapsed && styles.collapsed
              )}
            >
             {collapseIcon}
            </span>
          ) : <span className={styles.expandMoreEmpty} />}
          
          <span {...handleProps} 
            className={styles.Text} 
            onClick={onItemBtnClick}
            onContextMenu={onContextMenuBtn}
            dangerouslySetInnerHTML={{__html: textValue()}}
            ></span>
          
          {!clone && missingMedia && <span className={styles.cautionIcon} title="Missing media file">{cautionIcon}</span>}
          {!clone && btn1 && <span onClick={handleBtn1} className={classNames(visible ? "isVisible" : "notVisible", "layerBtn")}>{btn1}</span>}
          {!clone && btn2 && <span onClick={handleBtn2} className={classNames(locked && "isLocked", "layerBtn")}>{btn2}</span>}
          {!clone && onRemove && <span onClick={onRemove}>X</span>}
          {clone && childCount && childCount > 1 ? (
            <span className={styles.Count}>{childCount}</span>
          ) : null}
        </div>
      </li>
    );
  }
);


const collapseIcon = (
  <svg width="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 41">
    <path fill="white" d="M30.76 39.2402C31.885 40.3638 33.41 40.995 35 40.995C36.59 40.995 38.115 40.3638 39.24 39.2402L68.24 10.2402C69.2998 9.10284 69.8768 7.59846 69.8494 6.04406C69.822 4.48965 69.1923 3.00657 68.093 1.90726C66.9937 0.807959 65.5106 0.178263 63.9562 0.150837C62.4018 0.123411 60.8974 0.700397 59.76 1.76024L35 26.5102L10.24 1.76024C9.10259 0.700397 7.59822 0.123411 6.04381 0.150837C4.4894 0.178263 3.00632 0.807959 1.90702 1.90726C0.807714 3.00657 0.178019 4.48965 0.150593 6.04406C0.123167 7.59846 0.700153 9.10284 1.75999 10.2402L30.76 39.2402Z" />
  </svg>
);

const folderIcon = (
  `<svg class="icon folderIcon" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2033_1429)">
      <path d="M2 16.5C1.45 16.5 0.979167 16.3042 0.5875 15.9125C0.195833 15.5208 0 15.05 0 14.5V2.5C0 1.95 0.195833 1.47917 0.5875 1.0875C0.979167 0.695833 1.45 0.5 2 0.5H8L10 2.5H18C18.55 2.5 19.0208 2.69583 19.4125 3.0875C19.8042 3.47917 20 3.95 20 4.5V14.5C20 15.05 19.8042 15.5208 19.4125 15.9125C19.0208 16.3042 18.55 16.5 18 16.5H2ZM2 14.5H18V4.5H9.175L7.175 2.5H2V14.5Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_2033_1429">
    <rect width="20" height="16" fill="white" transform="translate(0 0.5)"/>
    </clipPath>
    </defs>
  </svg>`

)

const cautionIcon = (
  <svg width="16" height="16" viewBox="0 -960 960 960" xmlns="http://www.w3.org/2000/svg">
    <path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z" fill="#FFC107"/>
  </svg>
)